import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

export const Toggle: React.FC<{
  label: string;
  checked: boolean;
  onChange: (_value: boolean) => void;
}> = ({ label, checked, onChange }) => (
  <button
    type='button'
    className={`eh-toggle ${checked ? 'on' : ''}`}
    onClick={() => onChange(!checked)}
    role='switch'
    aria-checked={checked}
  >
    <span className='eh-toggle-track'>
      <span className='eh-toggle-thumb' />
    </span>
    <span className='eh-toggle-label'>{label}</span>
  </button>
);

export const ChipInput: React.FC<{
  values: string[];
  onChange: (_next: string[]) => void;
  placeholder?: string;
}> = ({ values, onChange, placeholder }) => {
  const [draft, setDraft] = useState('');
  const add = () => {
    const v = draft.trim();
    if (v && !values.includes(v)) onChange([...values, v]);
    setDraft('');
  };
  return (
    <div className='eh-chip-input'>
      {values.map((v) => (
        <span key={v} className='eh-chip'>
          {v}
          <button
            type='button'
            className='eh-chip-x'
            onClick={() => onChange(values.filter((x) => x !== v))}
            aria-label={`Remove ${v}`}
          >
            <CloseIcon style={{ fontSize: 13 }} />
          </button>
        </span>
      ))}
      <input
        className='eh-chip-field'
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            add();
          }
        }}
        onBlur={add}
        placeholder={values.length ? 'Add another…' : placeholder}
      />
    </div>
  );
};
